module.exports = __webpack_public_path__ + "static/media/branch.935c6789.svg";